import React from "react";
import PropTypes from "prop-types";
import WOW from "wowjs";

import { makeStyles,Button } from '@material-ui/core';




import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';
import "../styles/slider-animation.css";
import "../styles/styl-slider.css";
//import AwsSliderStyles from 'react-awesome-slider/src/styles.scss';
const theme = createMuiTheme();

const content = [
  {
    title: "Web Solution With NodeJS & React ",
    description:
      "Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras justo odio, dapibus ac facilisis.",
    button: "GitHub",
    image: "http://studiopixel.in/wp-content/uploads/2017/11/18a4949fc9c8067172d3b96e302e7097.gif",
    user: "Berriri SAAHBI",
    userProfile: "https://i7.pngflow.com/pngimage/876/166/png-web-development-software-developer-web-developer-computer-icons-world-wide-web-web-design-logo-sign-computer-programming-clipart.png"
  },
  {
    title: "Mobile Solution With React Native",
    description:
      "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras mattis consectetur purus sit amet fermentum. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Donec sed odio dui.",
    button: "Linkedin",
    image: "https://cdn.dribbble.com/users/205964/screenshots/6002888/scene-1-drib.gif",
    user: "Berriri SAHBI",
    userProfile: "https://i7.pngflow.com/pngimage/876/166/png-web-development-software-developer-web-developer-computer-icons-world-wide-web-web-design-logo-sign-computer-programming-clipart.png"
  },
  {
    title: "IT Solution",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Duis mollis, est non commodo luctus, nisi erat porttitor ligula.",
    button: "Resume",
    image: "https://cdn.dribbble.com/users/205964/screenshots/3506741/explainer_4.gif",
    user: "Berriri Sahbi",
    userProfile: "https://i7.pngflow.com/pngimage/876/166/png-web-development-software-developer-web-developer-computer-icons-world-wide-web-web-design-logo-sign-computer-programming-clipart.png"
  }
];

theme.typography.h3 = {
  fontSize: '1.2rem',
  '@media (min-width:600px)': {
    fontSize: '1.5rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem',
  },
};
const phoneData = [
	{
	  start: 'self',
	  startOffset: 300,
	  duration: 150,
	  easing: [0.30, 0.1, 0.5, 3],
	  properties: [
		{
		  startValue: 90,
		  endValue: 0,
		  property: 'rotate',
		},
		{
		  startValue: 0,
		  endValue: 1,
		  property: 'scale',
		},
	  ],
	},
  ];
  
  const contentData = [
	{
	  start: '.Phone',
	  startOffset: 400,
	  duration: 150,
	  properties: [
		{
		  startValue: 0,
		  endValue: -200,
		  unit: '%',
		  property: 'translateY',
		},
	  ],
	},
  ];


const useStyles = makeStyles((theme) => ({
  media: {
    height: '100%',
    paddingTop: '56.25%', // 16:9
  },
	root: {
	  flexGrow: 1,
	},
	letr :{
		position: "absolute",
left: "0px",
right: "0px",
top: "24px",
bottom: "0px",

background:" #FFFFFF"
	},
	paper: {
	  padding: theme.spacing(2),
	  textAlign: 'center',
	  color: theme.palette.text.secondary,
	},
  }));
			//	<Parallax small filter  image={ parlex}/>

export default class Background extends React.Component {
	componentDidMount() {
		new WOW.WOW().init();
	}

	



	render() {
		return (
			<div>
    
    <Slider className="slider-wrapper">
      {content.map((item, index) => (
        <div
          key={index}
          className="slider-content"
          style={{ background: `url('${item.image}') no-repeat center center` }}
        >
          <div className="inner">
            <h1>{item.title}</h1>
            <p>{item.description}</p>
           <a  href="/cv"><button >{item.button}</button></a>
          </div>
          <section>
            <img src={item.userProfile} alt={item.user} />
            <span>
              JS developer (NodeJS & React) <strong>{item.user}</strong>
            </span>
          </section>
        </div>
      ))}
    </Slider>
    </div>
				 
			
		);
	}
}

Background.propTypes = {
	aboutRef: PropTypes.object,
	bounceIn: PropTypes.string
};
